import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;


export const getTeacherAllocationListSvc = (callback) => {
    // console.log("getTeacherAllocationListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation_2/teacher/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getTeacherAllocationListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchAllocation = response.data.lstTeacher;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const saveTeacherAllocationSvc = (saveTeacherAllocationObj, callback) => {
    // console.log("saveTeacherAllocationSvc called");
    const formData = new FormData();
    formData.append("teacher", JSON.stringify(saveTeacherAllocationObj))
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation_2/teacher/save',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const allocateTeacherSvc = (callback) => {
    // console.log("allocateTeacherSvc called, wingId", wingId);
    const formData = new FormData();
    formData.append("wingId", wingId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation_2/allocate',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in allocateTeacherSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}
